<template>
    <div>
        <div class="columns">
            <div class="column is-12-mobile is-12-desktop is-12-widescreen">
                <div class="title is-marginless is-paddingless">Your Business billing information
                    <span :class="[{ 'is-loading': is_loading }, 'button is-white has-text-right preloader']"></span>
                </div>
            </div>
        </div>
        <div class="columns" v-if="!is_loading">
            <div class="column is-half-tablet">
                <basic-card title="Billing Details" class="margin-bottom-0">
                    <p>
                        <small>Registered name:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="business_name"></span>
                    </p>
                    <p>
                        <small>Registration number:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="registration_number"></span>
                    </p>
                    <p>
                        <small>VAT number:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="vat_number"></span>
                    </p>
                    <p>
                        <small>Billing address:</small>
                        <span class="has-text-weight-bold"><address v-html="billing_address"></address></span>
                    </p>
                    <p>
                        <small>Contact person:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="contact_person"></span>
                    </p>
                    <p>
                        <small>Contact email:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="contact_email"></span>
                    </p>

                    <button :disabled="package === 'Free'" class="button is-button-blue"
                            @click.prevent="editBillingDetails">EDIT BILLING DETAILS</button>

                    <button :disabled="package === 'Free'" class="button is-button-blue is-button-medium is-hidden-mobile is-hidden-touch is-hidden-tablet"
                            @click.prevent="editBillingDetails">EDIT BILLING DETAILS</button>
                    <p v-if="package === 'Free'" class="is-size-7 mar-top"><i>Billing details are only necessary for businesses on paid packages</i></p>
                </basic-card>
            </div>
            <div class="column is-half-tablet">
                <basic-card title="Package">
                    <p>
                        <small>Current subscription package:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="package"></span>
                    </p>
                    <p>
                        <small>Expires on:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="prettyExpiryDate"></span>
                    </p>

                    <p>
                        <small>Reviews remaining:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-html="review_remaining_copy"></span>
                        <br/>
                        <span class="has-text-weight-bold" v-if="package == 'Free'" v-text="review_replies_remaining_text"></span>
                    </p>

                    <p v-if="package === 'Lite (Monthly)' && !hasPendingSubscription && isExpiringWithinSixtyDaysOrFreeAccount">
                        <i>Your subscription to your Lite monthly package renews automatically. Only select "Renew" if
                            you would like to change your package or payment frequency
                        </i>
                    </p>
                    <p v-if="hasPendingSubscription">
                        <small>Pending subscription package:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="pending_name"></span>
                    </p>
                    <p v-if="hasPaidPendingSubscription">
                        <small>Activates on:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="prettyActivatesOnDate"></span>
                    </p>
                    <p v-if="!hasPaidPendingSubscription && hasPendingSubscription">
                        <span><i v-text="awaitingPaymentCopy"></i></span>
                    </p>

                    <router-link v-if="!hasPaidPendingSubscription && hasPendingSubscription && pending_method === 'CREDIT_CARD'"
                                 class="button is-button-blue is-button-medium"
                                 :to="`/renew-or-upgrade-subscription/card/${pending_invoice}`">PAY NOW</router-link>

                    <router-link v-if="!hasPendingSubscription && isExpiringWithinSixtyDaysOrFreeAccount"
                                 class="button is-button-blue is-button-medium"
                                 to="/renew-or-upgrade-subscription"
                                 v-text="renewOrUpgradeButton"></router-link>

                    <router-link v-if="!hasPendingSubscription && isExpiringWithinSixtyDaysOrFreeAccount"
                                 class="button is-button-blue is-button-medium is-hidden-mobile is-hidden-touch is-hidden-tablet"
                                 to="/renew-or-upgrade-subscription"
                                 v-text="renewOrUpgradeButton"></router-link>
                </basic-card>
                <basic-card title="Payment Details">
                    <p>
                        <small>Payment frequency:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="payment_frequency"></span>
                    </p>
                    <p>
                        <small>Payment method:</small>
                        <br/>
                        <span class="has-text-weight-bold" v-text="getPaymentMethod"></span>
                    </p>
                </basic-card>
            </div>
        </div>
    </div>
</template>
<style>
    .card-header > p {
        color: #58595b;
    }
</style>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import axios from 'axios'
  import moment from 'moment'
  import BillingModalDataStrucutre from './../../mixins/billing-details-modal-data.js'
  import BasicCard from './../card/BasicCard.vue'
  import ApiResource from './../../api/ApiResource.js'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Your business billing information'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Your business billing information'
      })
    },
    name: 'BillingDetails',
    components: {
      BasicCard
    },
    mixins: [
      BillingModalDataStrucutre
    ],
    data () {
      return {
        'now': moment(),
        'textInputModalProps': {},
        'is_loading': false,
        'package': '',
        'expires': '',
        'business_name': '',
        'registration_number': '',
        'vat_number': '',
        'billing_address': '',
        'contact_person': '',
        'contact_email': '',
        'payment_frequency': '',
        'payment_method': '',
        'pending_name': '',
        'pending_start_date': '',
        'pending_status': '',
        'pending_method': '',
        'pending_invoice': '',
        'reviews_remaining': '',
        'review_remaining_copy': '',
        'review_replies_remaining_text': ''
      }
    },
    computed: {
      /**
       * Just removing the underscore
       * @return {string}
       */
      getPaymentMethod () {
        return this.payment_method === 'CREDIT_CARD' ? 'CREDIT CARD' : this.payment_method
      },
      /**
       * Nicely formatted Expiry Date
       * @return {string}
       */
      prettyExpiryDate () {
        return moment(this.expires).format('DD MMMM YYYY')
      },
      hasPendingSubscription () {
        return !(this.pending_name === 'NONE' || this.pending_name === '')
      },
      hasPaidPendingSubscription () {
        return this.pending_start_date !== ''
      },
      prettyActivatesOnDate () {
        return moment(this.pending_start_date).format('DD MMMM YYYY')
      },
      renewOrUpgradeButton () {
        if (typeof this.package !== 'undefined' && this.package.toLowerCase().indexOf('free') !== -1) {
          return 'UPGRADE NOW'
        }
        return 'RENEW NOW'
      },
      isExpiringWithinSixtyDaysOrFreeAccount () {
        if (typeof this.package !== 'undefined' && this.package.toLowerCase().indexOf('free') !== -1) {
          return true
        }

        if (this.expires.length > 0) {
          const expires = moment(this.expires)
          return expires.diff(this.now, 'days') <= 60
        }
        return false
      },
      awaitingPaymentCopy () {
        // add button for pay now
        if (this.payment_method.length > 0 && this.payment_method === 'CREDIT_CARD') {
          return 'Awaiting Credit Card payment'
        }
        return 'Awaiting EFT payment confirmation'
      }
    },
    created () {
      this.getBusinessBillingDetails()
      this.getBusinessRemainingReviews()
      window.events.$on('addBillingDetails', this.processOps)
    },
    methods: {
      /**
       * Display appropriate copy based on subscription type
       * @param {object} data review remaining data
       * @returns {null}
       */
      reviewRemainingCopy (data) {
        if (data.subscription === 'Free' && parseInt(data.total_reviews_remaining) === 0) {
          this.review_remaining_copy = 'no reviews with customer data on the free package'
        } else if (data.subscription === 'Enterprise') {
          this.review_remaining_copy = 'Unlimited'
        } else {
          this.review_remaining_copy = `${data.total_reviews_remaining}&nbsp;&nbsp;<a href="/purchase-reviews" class="color-2aabe1">purchase more reviews</a>`
        }
        this.review_replies_remaining_text = `${data.review_replies_remaining} replies remaining`
      },
      /**
       * Make request to api to get business's remaining reviews
       * @returns {number | null}
       */
      getBusinessRemainingReviews () {
        let businesSlug = localStorage.getItem('org_slug')
        axios.get(`/${businesSlug}/remaining-reviews`)
            .then((response) => {
              this.reviews_remaining = response.data.total_reviews_remaining
              this.reviewRemainingCopy(response.data)
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
                dataLayer.push({
                    'userMessage': {
                        'messageType': 'error',
                        'messageName': 'Failed to get the number of remaining reviews on Billing Details View',
                        'displayedMessage': 'You are not authorized to view this resource.'
                    }
                })
            })
      },
      processOps (props) {
        let form = new ApiResource({
          business_reg_number: props.registrationNumber,
          business_reg_name: props.registeredName,
          business_vat_number: props.vatNumber,
          address: props.billingAddress,
          org_lat: props.org_lat,
          org_lng: props.org_lng,
          contact_person: props.contactPersonName,
          contact_email: props.contactPersonEmail
        })

        const businessSlug = localStorage.getItem('org_slug')
        form.send(`/${businessSlug}/billing-details`)
            .then(() => {
              this.getBusinessBillingDetails()
              flash('You have successfully updated your billing details', 'is-success')
                dataLayer.push({
                    'userMessage': {
                        'messageType': 'success',
                        'messageName': 'Successfully updated billing details on Billing Details View',
                        'displayedMessage': 'You have successfully updated your billing details'
                    }
                })
            })
            .catch(() => {
                const msg = 'There was an error trying to update your billing details. ' + form.errors.getDefaultErrorMessage().split('<br/>').join(',')
              flash(msg, 'is-danger')
                dataLayer.push({
                    'userMessage': {
                        'messageType': 'error',
                        'messageName': 'Failed to update billing details on Billing Details View',
                        'displayedMessage': msg
                    }
                })
            })
      },
      getBusinessBillingDetails () {
        this.is_loading = true
        const businessSlug = localStorage.getItem('org_slug')
        axios.get(`/${businessSlug}/billing-details`)
            .then(({data}) => {
              this.package = data.subscription.name
              this.expires = data.subscription.expires
              this.business_name = data.billing_details.registered_name
              this.registration_number = data.billing_details.registration_number
              this.vat_number = data.billing_details.vat_number
              this.contact_person = data.contact_person.name
              this.contact_email = data.contact_person.email
              this.payment_frequency = data.payment_plan.frequency
              this.payment_method = data.payment_plan.payment_method
              const addressDataResponse = data.billing_details.billing_address
              this.billing_address = this.createAddressLines(addressDataResponse)
              this.pending_name = data.pendingSubscription.name
              this.pending_status = data.pendingSubscription.status

              if (typeof data.pendingSubscription.method !== 'undefined') {
                this.pending_method = data.pendingSubscription.method
              }
              if (typeof data.pendingSubscription.invoice_id !== 'undefined') {
                this.pending_invoice = data.pendingSubscription.invoice_id
              }
              if (typeof data.pendingSubscription.startDate !== 'undefined') {
                this.pending_start_date = data.pendingSubscription.startDate
              }
              this.is_loading = false
              localStorage.setItem('billingDetails', JSON.stringify(data))
              this.textInputModalProps = this.buildModalProps(data, addressDataResponse)
            })
            .catch(() => {
              flash('Oops, something went wrong. Please try reloading or contact our administrator', 'is-danger')
              this.is_loading = false
                dataLayer.push({
                    'userMessage': {
                        'messageType': 'error',
                        'messageName': 'Failed to get billing details on Billing Details View due to server error',
                        'displayedMessage': 'Oops, something went wrong. Please try reloading or contact our administrator'
                    }
                })
            })
      },
      /**
       * Take a string of comma separated address lines and replace with html break tag
       * @param {string} commaSeparatedAddress The string that has address lines spearated bny a comma
       * @return {string}
       */
      createAddressLines (commaSeparatedAddress) {
        if (typeof commaSeparatedAddress === 'undefined' || commaSeparatedAddress === null) {
          return ''
        }
        const addressData = commaSeparatedAddress.split(',').map((item) => {
          return item.trim()
        })
        return addressData.join('<br/>')
      },
      editBillingDetails () {
        let options = {
          title: 'Edit billing contact details',
          body: '',
          btn_action_title: 'SAVE CHANGES',
          show_btns: true,
          task: 'addBillingDetails',
          producer: {},
          textInputFields: this.textInputModalProps
        }
        modal(options)
      }
    }
  }
</script>
<style scoped>
    .mar-top {
        margin-top: 0.75rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/billing/Details.vue